module.exports = __webpack_public_path__ + "static/media/logo.df4fc325.svg";